import React, { useRef, useState, useEffect } from "react";
import Modal from "react-bootstrap/Modal";
import { Mensaje, MensajeSiNo } from "../../../mensajes2";

import { Dimmer } from "../../../spinner";
import { validaSoloNumero, formatMoneda } from "../../../../util/varios";
import { DangerButton, PrimaryButton, SuccessButton } from "../../../../ui/buttons/Button";
import useTableFijo from "../../../useTableFijo";
import axios from "axios";
import moment from "moment";

export const ProcesarNomina = (props) => {
    const nominaSel = JSON.parse(localStorage.getItem('codigonomina'));
    let token = localStorage.getItem("jwtToken");
    let op = require("../../../../modulos/datos");


    const headCells = [
        {
            id: "1",
            backgroundColor: "rgba(5, 81, 130, 1)",
            color: "#ffffff",
            label: "Cód. Concepto",
            textAlign: "center",
        },
        {
            id: "2",
            backgroundColor: "rgba(5, 81, 130, 1)",
            color: "#ffffff",
            label: "Nom. Concepto",
            textAlign: "center",
        },
        {
            id: "2",
            backgroundColor: "rgba(5, 81, 130, 1)",
            color: "#ffffff",
            label: "Días/Hora",
            textAlign: "center",
        },
        {
            id: "2",
            backgroundColor: "rgba(5, 81, 130, 1)",
            color: "#ffffff",
            label: "Asignaciones",
            textAlign: "center",
        },
        {
            id: "2",
            backgroundColor: "rgba(5, 81, 130, 1)",
            color: "#ffffff",
            label: "Deducciones",
            textAlign: "center",
        },
    ];

    const btnCancela = useRef();
    const btnAcepta = useRef();
    const txtCodInt = useRef();
    const txtNomInt = useRef();
    const txtCodDep = useRef();
    const txtNomDep = useRef();
    const txtCodUni = useRef();
    const txtNomUni = useRef();
    const txtAsignacion = useRef();
    const txtDeduccion = useRef();
    const txtTotal = useRef();
    const txtItems = useRef();
    const txtPeriodo = useRef();


    const [mensaje, setMensaje] = useState({
        mostrar: false,
        titulo: "",
        texto: "",
        icono: "",
    });
    const [mensajesino, setMensajesino] = useState({
        mostrar: false,
        titulo: "",
        texto: "",
        icono: "",
    });
    const [records, setRecords] = useState([]);
    const [conceptos, setConceptos] = useState([]);
    const [integrantes, setIntegrantes] = useState();
    const [posi, setPosi] = useState(0);
    const [posiAux, setPosiAux] = useState(0);
    const [values, setValues] = useState({});
    const [itemSelect, setItemSelect] = useState(-1);
    const [deshabilitado, setDeshabilitado] = useState(true);
    const [deshabilitadoT, setDeshabilitadoT] = useState(false);
    const [activate, setActivate] = useState(false);
    const [fechaSistema, setFechaSistema] = useState(
        localStorage.getItem("fechasistema")
    );
    const [filterFn, setFilterFn] = useState({
        fn: (items) => {
            return items;
        },
    });
    const {
        TblContainer,
        TblHead,
        recordsAfterPagingAndSorting,
    } = useTableFijo(records, headCells, filterFn, 220);


    const [habilitadoNR, setHabilitadoNR] = useState(false);
    const [operacion, setOperacion] = useState(0);


    const handleCloseSi = () => {

        setMensajesino({ mostrar: false, titulo: "", texto: "", icono: "" });
    };




    const salir = (e) => {
        e.preventDefault();
        blanquear();
        props.onHideCancela();
    };


    const onChangeValidar = (e) => {
        e.preventDefault();



    };

    const cerrarModal = () => {
        setMensajesino({ mostrar: false, titulo: "", texto: "", icono: "" });
        setMensaje({ mostrar: false, titulo: "", texto: "", icono: "" });

        props.onHideCancela();
    };

    const seleccionarRegistros = () => {
        setActivate(true);
        let esquema = "nomi" + nominaSel;

        let endpoint = op.conexion + `/api/nomina/seleccionartemporalnomina?esquema=${esquema}`;
        axios
            .get(endpoint, {
                headers: {
                    "x-access-token": `${token}`,
                },
            })
            .then(function (response) {
                if (response.status === 200) {
                    var inte = [];
                    var pos = -1;
                    var codant = "";
                    for (let i = 0; i < response.data.length; i++) {
                        if (codant !== response.data[i].codint) {
                            pos++;
                            codant = response.data[i].codint;
                            inte.push({
                                pos: pos,
                                codint: response.data[i].codint,
                                nomint: response.data[i].nomint,
                                coddep: response.data[i].coddep,
                                nomdep: response.data[i].nomdep,
                                coduni: response.data[i].coduni,
                                nomuni: response.data[i].nomuni,
                            });
                        }
                    }
                    setIntegrantes(inte);
                    setPosi(0);
                    txtCodInt.current.value = inte[0].codint.trim();
                    /*txtNomInt.current.value = inte[0].nomint;
                    txtCodDep.current.value = inte[0].coddep;
                    txtNomDep.current.value = inte[0].nomdep;
                    txtCodUni.current.value = inte[0].coduni;
                    txtNomUni.current.value = inte[0].nomuni;*/
                    setRecords(response.data);
                    var concep = response.data;
                    var concep = concep.filter(function (concep) {
                        return concep.codint === inte[0].codint;
                    });
                    setConceptos(concep);
                    calcularTotales(concep);
                }
                setActivate(false);
            })
            .catch(function (error) {
                setMensaje({ mostrar: true, titulo: 'Error', texto: error.response.data.message, icono: 'error' });
                setActivate(false);
            });
    };

    const blanquear = () => {
        setMensaje({ mostrar: false, titulo: '', texto: '', icono: '' })
        setItemSelect("");
        setActivate(false);
        setRecords([]);
        setPosi(-1);
        setPosiAux(-1);
        setDeshabilitadoT(false)
        //setActivo(true);
    }

    const seleccionarFila = (index) => (event) => {
        setItemSelect(index);
        // setActivo(false);
        //setSelect(parseInt(nominaSel));
        var codconcep = conceptos[index].codconcep;
        var nomconcep = conceptos[index].nomconcep;
        var valcon = conceptos[index].valcon;
        var tipcon = conceptos[index].tipcon;
        var monto = conceptos[index].monto;

        var datos = [];
        datos.push({
            codconcep,
            nomconcep,
            valcon,
            tipcon,
            monto

        })
        setValues(datos);
    };

    const calcularTotales = (data) => {
        let totMon = parseFloat(0.00), totAsigna = parseFloat(0.00), totDedu = parseFloat(0.00);
        let totalItem = parseInt(0);
        for (let i = 0; i < data.length; i++) {
            totalItem = totalItem + 1;
            totAsigna = totAsigna + (data[i].tipcon === "A" ? parseFloat(data[i].monto) : parseFloat(0.00));
            totDedu = totDedu + (data[i].tipcon === "D" ? parseFloat(data[i].monto) : parseFloat(0.00));
        }
        totMon = totAsigna - totDedu;

        txtItems.current.value = totalItem;
        txtAsignacion.current.value = formatMoneda(totAsigna.toString().replace('.', ','), ',', '.', 2)
        txtDeduccion.current.value = formatMoneda(totDedu.toString().replace('.', ','), ',', '.', 2)
        txtTotal.current.value = formatMoneda(totMon.toString().replace('.', ','), ',', '.', 2)
    }

    const handleCodigoIntegrante = (e) => {
        e.preventDefault();
        //setPosiAux(posi);
        setPosi(-1);
        setConceptos();
    };

    const validarCodigoInte = (event) => {
        event.preventDefault();

        //validaSoloNumero(event);
        if (event.which === 13 || typeof event.which === "undefined") {
            if (event.target.value !== "") {
                var concep = records;
                var concep = concep.filter(function (concep) {
                    return concep.codint.trim() === event.target.value.trim();
                });
                if (concep.length > 0) {
                    setConceptos(concep);
                    calcularTotales(concep);
                    var inte = integrantes;
                    var inte = inte.filter(function (inte) {
                        return inte.codint.trim() === event.target.value.trim();
                    });
                    setPosi(inte[0].pos);
                    setDeshabilitado(true);
                } else {
                    txtCodInt.current.value = "";
                    setMensaje({ mostrar: true, titulo: 'Notificación', texto: 'El Integrante no Existe.', icono: 'informacion' });
                }

            } else {
                setPosi(-1);
                setConceptos();
            }
        }
    };

    const handleBotones = (cual) => (e) => {
        e.preventDefault();
        var pos = posi;
        //var codigo = integrantes[posi].codint;
        if (cual === 1) {
            pos = 0;
        } else if (cual === 2) {
            if (posi === integrantes.length - 1) {
                pos = posi;
            } else {
                pos = posi + 1;
            }
        } else if (cual === 3) {
            if (posi === 0) {
                pos = posi;
            } else {
                pos = posi - 1;
            }
        } else if (cual === 4) {
            pos = integrantes.length - 1;
        }
        /*codigo = integrantes[pos].codint;
        txtCodInt.current.value = codigo;
        setPosi(pos);
        var concep = records;
        var concep = concep.filter(function (concep) {
            return concep.codint.trim() === codigo.trim();
        });
        setConceptos(concep);
        calcularTotales(concep);*/
        seleccionarIntegrante(pos);
    };

    const cancelar = (e) => {
        e.preventDefault();
        setDeshabilitado(true)
        var pos = posiAux;
        setPosiAux(0);
        seleccionarIntegrante(pos);
    };

    const seleccionarIntegrante = (pos) => {
        var codigo = integrantes[pos].codint;
        txtCodInt.current.value = codigo.trim();
        setPosi(pos);
        var concep = records;
        var concep = concep.filter(function (concep) {
            return concep.codint.trim() === codigo.trim();
        });
        setConceptos(concep);
        calcularTotales(concep);
    };

    return (
        <Modal
            {...props}
            size="lg"
            aria-labelledby="contained-modal-title-vcenter"
            centered
            backdrop="static"
            keyboard={false}
            onShow={() => {
                txtPeriodo.current.value = "Nº " + localStorage.getItem('numperiodo') +
                                        " Del " + moment.utc(JSON.parse(localStorage.getItem('fechainiper'))).format("DD/MM/YYYY")
                                        + " AL " + moment.utc(JSON.parse(localStorage.getItem('fechafinper'))).format("DD/MM/YYYY");
                seleccionarRegistros();
            }}
        >
            <Modal.Header className="azulGradiant modal-header">


                Elaborar Nomina
                <button
                    ref={btnCancela}
                    className="btn"
                    style={{ border: 0, margin: 0, padding: 0, color: "#ffffff" }}
                    onClick={salir}
                >
                    <i className="far fa-window-close"></i>
                </button>
            </Modal.Header>
            <Modal.Body>
                <div className="tipo-letra" style={{ height: "auto" }}>
                    <div className="col-md-12 row mx-auto px-0">

                        <div className="input-group input-group-sm mb-2 col-md-5 my-auto">
                            <span className="input-group-text"><strong>Período</strong></span>
                            <input type="text" className="form-control text-uppercase" readOnly ref={txtPeriodo} />
                        </div>
                        <div className="d-flex justify-content-end gap-2 mb-2 col-md-7">
                            <button className="btn btn-primary rounded-pill" onClick={handleBotones(1)} disabled={deshabilitadoT ? deshabilitadoT : !deshabilitado} >
                                <i className="fas fa-angle-double-left"></i> Primero
                            </button>

                            <button className="btn btn-primary rounded-pill" onClick={handleBotones(2)} disabled={deshabilitadoT ? deshabilitadoT : !deshabilitado} >
                                Siguiente <i className="fas fa-angle-right"></i>
                            </button>
                            <button className="btn btn-primary rounded-pill" onClick={handleBotones(3)} disabled={deshabilitadoT ? deshabilitadoT : !deshabilitado} >
                                <i className="fas fa-angle-left"></i> Anterior
                            </button>
                            <button className="btn btn-primary rounded-pill" onClick={handleBotones(4)} disabled={deshabilitadoT ? deshabilitadoT : !deshabilitado} >
                                Ultimo<i className="fas fa-angle-double-right"></i>
                            </button>
                        </div>

                        <div className="input-group input-group-sm mb-1 col-md-4">
                            <span className="input-group-text"><strong>Cód. Integrante</strong></span>
                            <input type="text" className="form-control text-uppercase" ref={txtCodInt}
                                onChange={handleCodigoIntegrante}
                                onKeyUp={validarCodigoInte}
                                onBlur={validarCodigoInte}
                                readOnly={deshabilitadoT ? deshabilitadoT : deshabilitado}
                            />
                            <button className="btn btn-success" disabled={deshabilitadoT ? deshabilitadoT : deshabilitado}>
                                <i className="fas fa-search"></i>

                            </button>
                        </div>
                        <div className="input-group input-group-sm mb-1 col-md-8">
                            <span className="input-group-text"><strong>Nombre</strong></span>
                            <input type="text" className="form-control text-uppercase" readOnly ref={txtNomInt} value={integrantes && posi >= 0 ? integrantes[posi].nomint : ""} />
                        </div>


                        <div className="input-group input-group-sm mb-1 col-md-4">
                            <span className="input-group-text"><strong>Cód. Unidad Funcional</strong></span>
                            <input type="text" className="form-control text-uppercase" readOnly ref={txtCodUni} value={integrantes && posi >= 0 ? integrantes[posi].coduni : ""} />
                        </div>
                        <div className="input-group input-group-sm mb-1 col-md-8">
                            <span className="input-group-text"><strong>Nombre</strong></span>
                            <input type="text" className="form-control text-uppercase" readOnly ref={txtNomUni} value={integrantes && posi >= 0 ? integrantes[posi].nomuni : ""} />
                        </div>

                        <div className="input-group input-group-sm mb-1 col-md-4">
                            <span className="input-group-text"><strong>Cód. Departamento</strong></span>
                            <input type="text" className="form-control text-uppercase" readOnly ref={txtCodDep} value={integrantes && posi >= 0 ? integrantes[posi].coddep : ""} />
                        </div>
                        <div className="input-group input-group-sm mb-1 col-md-8">
                            <span className="input-group-text"><strong>Nombre</strong></span>
                            <input type="text" className="form-control text-uppercase" readOnly ref={txtNomDep} value={integrantes && posi >= 0 ? integrantes[posi].nomdep : ""} />
                        </div>


                        <TblContainer
                            container={{ height: 250, width: "100%", overflow: "auto" }}
                        >
                            <TblHead />
                            <tbody>
                                {conceptos &&
                                    conceptos.map((item, index) => (
                                        <tr
                                            key={item + item.codconcep}
                                            className="table-bordered"
                                            style={{
                                                padding: "0",
                                                cursor: "pointer",
                                                backgroundColor: itemSelect === index ? "lightskyblue" : "white",
                                            }}
                                            onClick={seleccionarFila(index)}
                                        >
                                            <td
                                                style={{
                                                    fontSize: "10px",
                                                    textAlign: "center",
                                                    width: "50px",
                                                }}
                                            >
                                                {item.codconcep}
                                            </td>
                                            <td
                                                style={{
                                                    fontSize: "10px",
                                                    textAlign: "left",
                                                    width: "350px",
                                                }}
                                            >
                                                {item.nomconcep}
                                            </td>
                                            <td
                                                style={{
                                                    fontSize: "10px",
                                                    textAlign: "right",
                                                    width: "350px",
                                                }}
                                            >
                                                {formatMoneda(item.valcon !== null ? item.valcon.toString().replace('.', ',') : "0.00", ',', '.', 2)}
                                            </td>
                                            <td
                                                style={{
                                                    fontSize: "10px",
                                                    textAlign: "right",
                                                    width: "350px",
                                                }}
                                            >
                                                {item.tipcon === "A" ? formatMoneda(item.monto.toString().replace('.', ','), ',', '.', 2) : ""}
                                            </td>
                                            <td
                                                style={{
                                                    fontSize: "10px",
                                                    textAlign: "right",
                                                    width: "350px",
                                                }}
                                            >
                                                {item.tipcon === "D" ? formatMoneda(item.monto.toString().replace('.', ','), ',', '.', 2) : ""}
                                            </td>
                                        </tr>
                                    ))}
                            </tbody>
                        </TblContainer>


                        <div className="d-flex justify-content-between mt-3 gap-2">
                            <div className="input-group">
                                <span className="input-group-text"><strong>Items</strong></span>
                                <input type="text" className="form-control text-uppercase" ref={txtItems} readOnly />
                            </div>

                            <div className="input-group">
                                <span className="input-group-text"><strong>Asignaciones</strong></span>
                                <input type="text" className="form-control text-uppercase" style={{ textAlign: "right" }} ref={txtAsignacion} readOnly />
                            </div>

                            <div className="input-group">
                                <span className="input-group-text"><strong>Deducciones</strong></span>
                                <input type="text" className="form-control text-uppercase" style={{ textAlign: "right" }} ref={txtDeduccion} readOnly />
                            </div>

                            <div className="input-group">
                                <span className="input-group-text"><strong>Total</strong></span>
                                <input type="text" className="form-control text-uppercase" style={{ textAlign: "right" }} ref={txtTotal} readOnly />
                            </div>
                        </div>


                    </div>
                </div>
            </Modal.Body>

            <Modal.Footer>
                <div className="d-flex justify-content-center flex-wrap my-3 mx-auto row">
                    <div className="btn-group shadow-0 mx-auto" role="group">
                        {/*<button className="mx-2 btn btn-success rounded-pill">
                            <i className="fas fa-search me-1"></i> Buscar
                        </button>*/}
                        <button className="mx-2 btn btn-info rounded-pill" disabled={deshabilitadoT ? deshabilitadoT : !deshabilitado} 
                            onClick={() => {setDeshabilitado(false);
                                txtCodInt.current.value = "";
                                setPosiAux(posi);
                                setPosi(-1);
                                setConceptos();
                            }}>
                            <i className="fas fa-eye me-1"></i> Consultar
                        </button>
                        <button className="mx-2 btn btn-danger rounded-pill" disabled={deshabilitadoT ? deshabilitadoT : !deshabilitado} onClick={() =>{setDeshabilitadoT(true)} }>
                            <i className="fas fa-trash-alt me-1"></i> Eliminar
                        </button>
                        <button className="mx-2 btn btn-warning rounded-pill" disabled={deshabilitadoT ? deshabilitadoT : !deshabilitado} >
                            <i className="fas fa-print me-1"></i> Imprimir
                        </button>
                        <button className="mx-2 btn btn-secondary rounded-pill" disabled={deshabilitadoT ? deshabilitadoT : deshabilitado} onClick={cancelar} >
                            <i className="fas fa-ban me-1" ></i> Cancelar
                        </button>

                        <button className="mx-2 btn btn-danger rounded-pill" disabled={deshabilitadoT ? false : !deshabilitado} onClick={salir} >
                            <i className="fa fa-times ms-1" ></i> Salir
                        </button>

                    </div>
                </div>



            </Modal.Footer>
            <Mensaje
                mensaje={mensaje}
                onHide={() => {
                    mensaje.titulo === "Exito."
                        ? cerrarModal()
                        : setMensaje({
                            mostrar: false,
                            titulo: "",
                            texto: "",
                            icono: "",
                        });
                }}
            />
            <MensajeSiNo
                mensaje={mensajesino}
                onHideNo={() =>
                    setMensajesino({ mostrar: false, titulo: "", texto: "", icono: "" })
                }
                onHideSi={handleCloseSi}
            />

            <Dimmer active={activate}></Dimmer>

        </Modal>
    );
};
